<template>
  <section class="px-4 py-12 md:py-16">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.programme.title') }}</h2>
      <p class="text-lg md:text-xl text-neutral-200 max-w-2xl">{{ t('landing.programme.body') }}</p>

      <div class="w-full mt-4 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          v-for="(feature, index) in FEATURES"
          :key="feature"
          class="p-6 rounded-2xl bg-neutral-700 text-left flex flex-col gap-2"
        >
          <VaIcon :name="ICONS[index]" color="primary" size="28px" />
          <h3 class="mt-0 mb-0">{{ t(`landing.programme.${feature}.title`) }}</h3>
          <p class="text-neutral-300 mt-0 mb-0">{{ t(`landing.programme.${feature}.text`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { VaIcon } from 'vuestic-ui'

const { t } = useI18n()

const FEATURES = ['fresh', 'nonstop', 'noAds', 'free'] as const
const ICONS = ['new_releases', 'all_inclusive', 'campaign', 'savings']
</script>
